import React from 'react';
import { PenLine, Eye, Copy } from 'lucide-react';

const HowToUse = () => {
  const steps = [
    {
      id: 1,
      icon: <PenLine size={24} />,
      title: "Enter video title",
      description: "Enter your video title or keyword in the search bar to generate tags for your YouTube video."
    },
    {
      id: 2,
      icon: <Eye size={24} />,
      title: "Preview generated tags",
      description: "Preview the generated tags and make any necessary adjustments to fit your YouTube video's content."
    },
    {
      id: 3,
      icon: <Copy size={24} />,
      title: "Copy your generated tags",
      description: "Copy the generated tags to your clipboard and paste them into your YouTube video's metadata for improved discoverability."
    }
  ];

  return (
    <div className="w-full max-w-4xl mx-auto mt-16 md:mt-24 mb-8 md:mb-12 px-4 animate-in fade-in slide-in-from-bottom-8 duration-700">
      <div className="text-center mb-8 md:mb-12">
        <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-semibold tracking-tight mb-3 md:mb-4">
          How to use the Tag Generator
        </h2>
        <p className="text-sm md:text-base lg:text-lg text-muted-foreground max-w-2xl mx-auto leading-relaxed">
          Generate YouTube tags in three simple steps. The SuperTags makes it easy to improve your video metadata for better discoverability. For free!
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
        {steps.map((step) => (
          <div 
            key={step.id} 
            className="border border-border bg-card p-6 md:p-8 flex flex-col items-center text-center hover:border-accent transition-colors duration-300 group rounded-lg"
          >
            <div className="w-12 h-12 bg-secondary text-secondary-foreground flex items-center justify-center rounded-none mb-4 md:mb-6 group-hover:bg-accent group-hover:text-accent-foreground transition-colors">
              {step.icon}
            </div>
            <h3 className="text-lg md:text-xl font-heading font-medium mb-2 md:mb-3">
              Step {step.id} - {step.title}
            </h3>
            <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
              {step.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HowToUse;
